// ЭТОТ ФАЙЛ НЕ ТРОГАТЬ !!!!!

import { AxiosInstance } from 'axios'
import { refreshToken } from '@root-gipro/store/api/index'

const interseptor = (root: AxiosInstance) => {
	let isAlreadyFetchingAccessToken = false
	let subscribers: Array<(access_token: string) => void> = []

	const onAccessTokenFetched = (access_token: string): void => {
		subscribers.forEach(callback => callback(access_token))
		subscribers = []
	}

	const addSubscriber = (callback: (access_token: string) => void): void => {
		subscribers.push(callback)
	}

	root.interceptors.response.use(
		response => response,
		async error => {
			const {
				config,
				response: { status },
			} = error
			const originalRequest = config

			if (status === 401 && !originalRequest._retry) {
				originalRequest._retry = true

				const refresh_token = localStorage.getItem('refresh_token')
				if (!refresh_token) {
					localStorage.removeItem('access_token')
					localStorage.removeItem('refresh_token')
					window.location.href = '/login'
					return Promise.reject(error)
				}

				const retryOriginalRequest = new Promise(resolve => {
					addSubscriber((access_token: string) => {
						originalRequest.headers.Authorization = `Bearer ${access_token}`
						resolve(root(originalRequest))
					})
				})

				if (!isAlreadyFetchingAccessToken) {
					isAlreadyFetchingAccessToken = true

					refreshToken(refresh_token)
						.then(response => {
							const { access_token } = response
							localStorage.setItem('access_token', access_token)
							root.defaults.headers.Authorization = `Bearer ${access_token}`
							onAccessTokenFetched(access_token)
						})
						.catch(err => {
							subscribers = []
							localStorage.removeItem('access_token')
							localStorage.removeItem('refresh_token')
							window.location.href = '/login'
						})
						.finally(() => {
							isAlreadyFetchingAccessToken = false
						})
				}

				return retryOriginalRequest
			}

			return Promise.reject(error)
		}
	)
}

export default interseptor
